// Which template fields to load into a quote. A well-formed template has a unique id per field,
// but two things break that:
// - orphaned copies: the SAME charge left behind in more than one place in the Offer Structure.
//   Loading each would mint a duplicate field and a duplicate default-cost buying rate, inflating
//   Sell and Cost in the profit bar, so only the first is loaded;
// - sections made with "duplicate section" before it gave the copies new ids: the copied fields
//   were then renamed or repriced into different charges that still share the original's id.
//   Those are real charges and must load (a whole section came up empty otherwise).
// So a field whose id was already loaded is dropped only when it is an identical copy (same
// title, type, default price and charge code). Returns a predicate for Array.filter.
export function templateFieldFilter() {
    const seen = {};
    const signature = f => JSON.stringify([
        (f.title || '').trim(), f.type || null, f.default?.value ?? null, f.default?.formula ?? null,
        f.default?.currency ?? f.currency ?? null, f.cargowiseChargeCode ?? null,
    ]);
    return f => {
        if (!f?.id) return true;
        const sig = signature(f);
        if (!seen[f.id]) {
            seen[f.id] = new Set([sig]);
            return true;
        }
        if (seen[f.id].has(sig)) return false;
        seen[f.id].add(sig);
        return true;
    };
}
